<app-card-layout-content class="network-error-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <img [src]="imagePath" aria-hidden="true" alt="" />
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Si è verificato un errore</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <span class="network-error-page__description" i18n>
        Controlla lo stato della tua connessione, oppure se hai installato delle applicazioni antispam che non
        permettono il normale funzionamento di {{ brandName }}.
      </span>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
</app-card-layout-content>
